// extracted by mini-css-extract-plugin
export default {"parallax-texts-wrapper":"ParallaxTexts_parallax-texts-wrapper__qIq64","parallax-text":"ParallaxTexts_parallax-text__s9dll","float":"ParallaxTexts_float__muqES"};